import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { FormControl, TextField } from '@mui/material'
import { Dayjs } from 'dayjs'
import dayjs from 'dayjs'
import SVG from 'react-inlinesvg'
import { SVGS } from '@/assets/svgs'

interface PickerProps {
  value?: Dayjs | null
  isError?: boolean
  errorText?: string
  onChange: (date: Dayjs | null) => void
  minDate?: Dayjs
  maxDate?: Dayjs
}

const CustomCalendarIcon: React.FC<any> = () => <SVG src={SVGS.CalendarColoredIcon} />

// Pre-built constraints for date of birth fields
export const dateOfBirthProps = {
  maxDate: dayjs().subtract(13, 'year'), // must be at least 13 years old
  minDate: dayjs().subtract(120, 'year'), // reasonable lower bound
}

export function MDDatePicker({
  isError,
  errorText,
  onChange,
  value,
  minDate,
  maxDate,
}: PickerProps) {
  const onChangeDate = (date: Dayjs | null) => {
    setTimeout(() => {
      onChange(date)
    }, 300)
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <FormControl fullWidth variant='outlined' margin='normal'>
        <DatePicker
          onChange={onChangeDate}
          sx={{ width: '100%' }}
          value={value}
          minDate={minDate}
          maxDate={maxDate}
          slots={{
            openPickerIcon: CustomCalendarIcon,
            textField: (params) => (
              <TextField
                {...params}
                label={'date'}
                variant='outlined'
                fullWidth
                helperText={errorText}
                error={isError}
              />
            ),
          }}
        />
      </FormControl>
    </LocalizationProvider>
  )
}
